import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
const MySwal = withReactContent(Swal2);
Quill.register("modules/imageResize", ImageResize);

const AdminPanelMaterials = (props) => {
  const [templates, setTemplates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [departmentsSec, setDepartmentsSec] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [allowedV, setAllowedV] = useState("all");
  const [subject, setSubject] = useState("");
  const [files, setFiles] = useState([]);
  const [department, setDepartment] = useState("");
  const [departmentSec, setDepartmentSec] = useState("");
  const [template, setTemplate] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("mat");
  const [users, setUsers] = useState([]);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [{ size: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["link", "image", "video"],
    ],
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const handleTemplateChange = (e) => {
    setUploadFilesArray([]);
    setTemplate(e.target.value);
    if (e.target.value === "new") {
      var content = "";
      var subject = "";
      var department = "";
      var departmentSec = "";
      var allowed = "all";
    } else {
      var content = !templates.filter((el) => +el.id === +e.target.value)[0]
        .content
        ? ""
        : templates.filter((el) => +el.id === +e.target.value)[0].content;
      var subject = !templates.filter((el) => +el.id === +e.target.value)[0]
        .name
        ? ""
        : templates.filter((el) => +el.id === +e.target.value)[0].name;
      var department = !templates.filter((el) => +el.id === +e.target.value)[0]
        .department
        ? ""
        : templates.filter((el) => +el.id === +e.target.value)[0].department;
      var departmentSec = !templates.filter(
        (el) => +el.id === +e.target.value
      )[0].departmentSec
        ? ""
        : templates.filter((el) => +el.id === +e.target.value)[0].departmentSec;
      var allowed = !templates.filter((el) => +el.id === +e.target.value)[0]
        .allowed
        ? ""
        : templates.filter((el) => +el.id === +e.target.value)[0].allowed;
    }

    setValue(content);
    setSubject(subject);
    setDepartment(department);
    setDepartmentSec(departmentSec);
    setAllowedV(allowed);
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMaterials", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchFiles();
      })
      .catch((error) => {});
  };

  const fetchFiles = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialFiles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFiles(data);
        fetchDepartments();
      })
      .catch((error) => {});
  };

  const fetchDepartments = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsDepartments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data);
        fetchDepartmentsSec();
      })
      .catch((error) => {});
  };

  const fetchDepartmentsSec = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsDepartmentsSec", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartmentsSec(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    setUploadFilesArray([]);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendTemplate = (e) => {
    if (
      template.length > 0 &&
      department.length > 0 &&
      departmentSec.length > 0 &&
      allowedV.length > 0
    ) {
      if (template === "new") {
        addTemplate();
      } else {
        updateTemplate();
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wybierz",
        text: "materiał",
      }).then(async (result) => {});
    }
  };

  const updateTemplate = async () => {
    var body = {
      id: template,
      name: subject,
      content: value,
      department: department,
      departmentSec: departmentSec,
      allowed: allowedV,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateMaterial", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        setValue("");
        setTemplate("");
        setSubject("");
        setDepartment("");
        setDepartmentSec("");
        setAllowedV("all");
        setUploadFiles([]);
        getData();
        var body2 = {
          materialId: template,
        };

        await fetch("https://apidevkppp.ftpeople.pl/clearMaterialFiles", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.text())
          .then(async (data) => {
            uploadFilesArray.map(async (file) => {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", "material");
              formData.append("materialId", template);
              formData.append("user", props.user.name);

              await fetch("https://apidevkppp.ftpeople.pl/uploadMaterialFile", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
                  return response.text();
                })
                .then((responseJson) => {});
            });

            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "materiał",
            }).then((result) => {
              getData();
            });
          });
      });
  };

  const addTemplate = async () => {
    var body = {
      name: templateName,
      content: value,
      department: department,
      departmentSec: departmentSec,
      allowed: allowedV,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertMaterial", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setValue("");
        setTemplate("");
        setSubject("");
        setDepartment("");
        setDepartmentSec("");
        setAllowedV("all");
        setUploadFiles([]);
        getData();

        uploadFilesArray.map(async (file) => {
          let formData = new FormData();
          formData.append("file", file);
          formData.append("type", "material");
          formData.append("materialId", data.insertId);
          formData.append("user", props.user.name);

          await fetch("https://apidevkppp.ftpeople.pl/uploadMaterialFile", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              return response.text();
            })
            .then((responseJson) => {});
        });
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "materiał",
        }).then((result) => {
          getData();
        });
      });
  };

  const deleteTemplate = async () => {
    var body = {
      id: template,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteMaterial", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "materiał",
        }).then((result) => {
          setValue("");
          setTemplate("");
          setSubject("");
          setDepartment("");
          setDepartmentSec("");
          setAllowedV("all");
          setUploadFiles([]);
          getData();
        });
      });
  };

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteMaterialFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "plik",
        }).then((result) => {
          getData();
        });
      });
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const documents = (
    <>
      <div style={{ marginTop: "3vh" }}></div>
      <input multiple={true} type="file" onChange={changeFiles} />

      {uploadFilesArray.length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Nazwa pliku</th>
              <th>Plik</th>
              <th></th>
            </tr>
            {uploadFilesArray.length > 0
              ? uploadFilesArray.map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "50%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                          <input
                            id={"fn" + index}
                            name={"fn" + index}
                            style={{ height: "2vh", marginTop: "0" }}
                            type="text"
                            value={inputs[index]}
                            onChange={(e) =>
                              setInputs((prev) => {
                                return {
                                  ...prev,
                                  [index]: e.target.value,
                                };
                              })
                            }
                          />
                          <button
                            className="refreshButton"
                            value={index}
                            onClick={changeFileName}
                          >
                            zmień
                          </button>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "40%",
                          padding: "5px 20px",
                          height: "3vh",
                          wordWrap: "anywhere",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={index}
                          onClick={deleteTempFile}
                        >
                          usuń
                        </button>
                      </td>
                    </tr>
                  </>
                ))
              : ""}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );

  const documentsView = (
    <>
      <div style={{ marginTop: "3vh" }}></div>

      {files.filter((el) => +el.materialId === +template).length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Plik</th>
              <th></th>
            </tr>
            {files.filter((el) => +el.materialId === +template).length > 0
              ? files
                  .filter((el) => +el.materialId === +template)
                  .map((el, index) => (
                    <>
                      <tr>
                        <td
                          style={{
                            textAlign: "left",
                            width: "40%",
                            padding: "5px 20px",
                            height: "3vh",
                            wordWrap: "anywhere",
                          }}
                        >
                          {el.name}
                        </td>
                        <td
                          style={{
                            textAlign: "left",
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          <button
                            className="refreshButton"
                            value={el.id}
                            onClick={deleteFile}
                          >
                            usuń
                          </button>
                        </td>
                      </tr>
                    </>
                  ))
              : ""}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <div className="mainContainerPayments">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            style={{ width: "100%" }}
            id="addPaymentIC"
            className="inputContainer"
          >
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Wybierz materiał <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {!template ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {templates.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                  <option key={"0x"} value={"new"}>
                    {"Nowy szablon"}
                  </option>
                </select>
              </div>
            </div>
            {template === "new" ? (
              <>
                <div style={{ marginTop: "3vh" }}>
                  <label>Nazwa szablonu</label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={templateName}
                    onChange={(e) => {
                      setTemplateName(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}
            {template !== "new" ? (
              <>
                <div style={{ marginTop: "3vh" }}>
                  <label>Nazwa szablonu</label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Dział <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={department}
                  onChange={(e) => {
                    setDepartment(e.target.value);
                  }}
                >
                  {!department || department === "" ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {departments.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Dział - poziom drugi <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={departmentSec}
                  onChange={(e) => {
                    setDepartmentSec(e.target.value);
                  }}
                >
                  {!departmentSec || departmentSec === "" ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {departmentsSec.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <label style={{ marginTop: "2vh" }}>Materiał</label>
            <div
              style={{
                marginTop: "1vh",
                border: "1px solid black",
                borderRadius: "15px",
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
              />
            </div>
            <>
              <div style={{ marginTop: "3vh" }}>
                <label>
                  Uprawnieni (wprowadź 'all' aby przyznać dostęp dla wszystkich,
                  lub poszczególne ID pracowników)
                </label>
                <input
                  type="text"
                  id="signature"
                  name="signature"
                  value={allowedV}
                  onChange={(e) => {
                    setAllowedV(e.target.value);
                  }}
                />
              </div>
            </>

            {documentsView}
            {documents}
            <div style={{ display: "flex", gap: "20px" }} className="saveBoxAP">
              {template.length > 0 ? (
                <>
                  <button className="paymentMenuButton" onClick={sendTemplate}>
                    Zapisz
                  </button>
                </>
              ) : (
                ""
              )}

              {template.length > 0 && template !== "new" ? (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={deleteTemplate}
                  >
                    Usuń
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div>
            <p>TABELA POMOCNICZA - UŻYTKOWNICY</p>
            <table
              id="detailClientTable"
              className="clients_table"
              style={{ width: "50%" }}
            >
              <tr>
                <th>ID</th>
                <th>Nazwa</th>
              </tr>
              {users.map((el) => (
                <>
                  <tr>
                    <td
                      style={{
                        width: "2%",
                        textAlign: "center",
                        paddingLeft: "0",
                      }}
                    >
                      {el.id}
                    </td>
                    <td
                      style={{
                        width: "15%",
                        textAlign: "left",
                        paddingLeft: "10px",
                      }}
                    >
                      {el.name}
                    </td>
                  </tr>
                </>
              ))}
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminPanelMaterials;
